import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    // Solo mostrar el botón en la página de Showroom
    const isShowroomPage = location.pathname === '/showroom';

    useEffect(() => {
        // Función para detectar el scroll
        const toggleVisibility = () => {
            // Mostrar el botón después de hacer scroll de 300px
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        // Agregar event listener
        window.addEventListener('scroll', toggleVisibility);

        // Limpiar el event listener cuando se desmonte el componente
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // Función para hacer scroll al inicio
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Solo renderizar en la página de Showroom
    if (!isShowroomPage) {
        return null;
    }

    return (
        <>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="scroll-to-top-btn"
                    aria-label="Volver arriba"
                >
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </button>
            )}
        </>
    );
}

export default ScrollToTopButton;